/***
 *
 *   AUTH PAGE CHROME
 *   Shared title / description / footer stack for auth views inside AuthLayout.
 *
 **********/

import Style from './authPage.tailwind';

export function AuthPage(props) {
    return (
        <div className={Style.stack}>
            {(props.title || props.description) && (
                <div className={Style.header}>
                    {props.title && <h2 className={Style.title}>{props.title}</h2>}
                    {props.description && (
                        <p className={Style.description}>{props.description}</p>
                    )}
                </div>
            )}
            {props.children}
            {props.footer && <div className={Style.footer}>{props.footer}</div>}
        </div>
    );
}
